import React from 'react'
import { Heading, useTheme } from '@aws-amplify/ui-react'
import logoImage from 'assets/images/masar-logo-en.svg'



export function SignInHeader() {
    const { tokens } = useTheme()

    return (
        <>
        
        
        <Heading level={3} padding={`${tokens.space.xl} ${tokens.space.xxxl} 0`}>
            <div className="flex mx-0">
                <div className="flex gap-3 p-0">
                    <div>
                        <img
                            src={logoImage}
                            alt=""
                            className="align-baseline"
                        />
                    </div>
                    <div className="pt-2">
                        {/* <div className="text-lg mb-0 font-bold" style={{ color: '#103875' }}>
                            Portal
                        </div> */}
                        {/* <div className="text-xl mb-0">
                            Financial Intelligence
                        </div>
                        <div className="text-xl">
                            National Center
                        </div> */}
                    </div>
                </div>
            </div>
        </Heading>

     
        </>
    )
}
